import getApi from '../../../api'

export const logoutStellair = () => getApi().post(`stellair/logout`)
